module.exports = __webpack_public_path__ + "static/img/wallet-balance.eefde8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/wallet-balance.png
// module id = vXqE
// module chunks = 1